// Pure qualification logic, deliberately separate from the data layer.
//
// The grid's one real decision — CONFIRMED versus PLACEHOLDER — lives here so
// it can be tested without loading the Supabase client. The admin app's Vitest
// runs in a node environment with no browser env vars, so anything importing
// `@/lib/supabase` is untestable there; keeping the logic free of it is the
// difference between this being covered and not.

export interface QualificationRow {
  id: string;
  staff_id: string;
  service_id: string;
  source: string;
  note: string | null;
  granted_by: string | null;
  created_at: string;
}

export type CellState = "confirmed" | "placeholder" | "none";

/** Grid lookup key. */
export function cellKey(staffId: string, serviceId: string): string {
  return `${staffId}:${serviceId}`;
}

/**
 * Index the live rows by (therapist, service).
 *
 * Anything that is not literally `'confirmed'` is treated as a placeholder. If
 * 0037 ever gains a third source, the safe default is "not certified" —
 * defaulting the other way would present unverified data as verified, which is
 * the exact failure the `source` column exists to prevent.
 */
export function buildQualificationIndex(rows: QualificationRow[]): Map<string, CellState> {
  const index = new Map<string, CellState>();
  for (const row of rows) {
    index.set(
      cellKey(row.staff_id, row.service_id),
      row.source === "confirmed" ? "confirmed" : "placeholder",
    );
  }
  return index;
}
